const Constants = Object.freeze({
    USER_TYPES: {
        ADMIN: 'admin',
        PROMOTOR: 'promotor',
        ASESOR: 'asesor',
        AUDITOR: 'auditor',
        GERENTE: 'gerente',
        ANALISTA: 'analista',
        LOCATION: 'location',
        CLIENT: 'client',
        TRADE_MARKETING: 'TradeMarketing',
        AUDIT_ANALYST: 'auditAnalyst',
    },
    CHANNEL: {
        MODERNO: 'moderno',
        TRADICIONAL: 'tradicional',
    },
});

export default Constants;
